import { analyticsApi } from "./analytics";

export const { useGetDashboardQuery } = analyticsApi;
